import { batch } from '@tmapy/redux';
import { actionUpdateSelectFeatureTool } from './components';
export const actionSelectFeatureInput = (payload) => (dispatch) => {
    batch('actionSelectFeatureInput', () => {
        // TODO set feature to layer as SELECTED - highlightedFeatureIds ???
        dispatch(actionUpdateSelectFeatureTool({
            selectedFeature: payload[0] || null,
            selectedFeatureData: null,
        }));
    });
};
//# sourceMappingURL=actionSelectFeatureInput.js.map